import "./App.css";

const Footer = () => {
	return (
		<footer>
			<div className="seperator"></div>
			<div className="icons">
				<i className="fa-brands fa-square-facebook fa-xl"></i>
				<i className="fa-brands fa-instagram fa-xl"></i>
			</div>

			<p>(c) 2023 Coffee Shop. All rights reserved.</p>
		</footer>
	);
};

export default Footer;
